class Event {

  constructor({ startTime, endTime, sortingStartTime, sortingEndTime, referenceId, paymentToken, title, description, url, dataset, style, barberToken, ...attributes }) {
    this.startTime = startTime
    this.endTime = endTime
    this.sortingStartTime = sortingStartTime || startTime
    this.sortingEndTime = sortingEndTime || endTime
    this.referenceId = referenceId
    this.paymentToken = paymentToken
    this.title = title
    this.description = description
    this.maxOverlaps = 1
    this.url = url
    this.barberToken = barberToken
    this.dataset = { url, referenceId, paymentToken, title, description, startTime, endTime, barberToken, ...dataset }
    this.style = style
    this.width = undefined
    this.left = undefined

    Object.assign(this, attributes)
  }

  get minutesToPercentageScale() {
    // Check if timetable controller has visible hours config
    if (global.timetableController?.visibleStartHour != null &&
        global.timetableController?.visibleEndHour != null) {
      const visibleDuration = (global.timetableController.visibleEndHour -
                              global.timetableController.visibleStartHour) * 60
      return 100.0 / visibleDuration
    }
    // Default to current behavior (full 24-hour day)
    return 100.0 / 1440.0
  }

  get visibleStartMinutes() {
    if (global.timetableController?.visibleStartHour != null) {
      return global.timetableController.visibleStartHour * 60
    }
    return 0  // Default to midnight
  }

  get startTimeMoment() {
    return global.moment(this.startTime)
  }

  get endTimeMoment() {
    return global.moment(this.endTime)
  }

  get startTimeToInteger() {
    return global.moment(this.sortingStartTime).valueOf()
  }

  get endTimeToInteger() {
    return global.moment(this.sortingEndTime).valueOf()
  }

  get duration() {
    return (this.endTimeMoment - this.startTimeMoment) / 1000 / 60
  }

  get durationToPercentage() {
    return this.duration * this.minutesToPercentageScale
  }

  get minutesSinceMidnight() {
    return (this.startTimeMoment.hour() * 60) + this.startTimeMoment.minute()
  }

  get minutesSinceMidnightToPercentage() {
    // If we have visible hours config, adjust for visible start
    const minutesSinceStart = this.minutesSinceMidnight - this.visibleStartMinutes
    return minutesSinceStart * this.minutesToPercentageScale
  }

  get top() {
    return this.minutesSinceMidnightToPercentage
  }

  get height() {
    return this.durationToPercentage
  }
}

export default Event
